import { render, staticRenderFns } from "./ns-select-popup.vue?vue&type=template&id=a5eb3a20&"
import script from "./ns-select-popup.vue?vue&type=script&lang=js&"
export * from "./ns-select-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports